// extracted by mini-css-extract-plugin
module.exports = {"container":"UploadPrescription-module__container___Lp0Zc","content":"UploadPrescription-module__content___iEgYb","presIcon":"UploadPrescription-module__presIcon___C1MVC"};